const SvgIconPause = props => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		focusable="false"
	>
		<rect x="6" y="5" width="3" height="10" rx="1" fill="currentColor" />
		<rect x="11" y="5" width="3" height="10" rx="1" fill="currentColor" />
	</svg>
);

export default SvgIconPause;
